import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	agileBoard: {
		id: 'classic-software.document-title.agile-board',
		defaultMessage: 'Agile Board',
		description: 'Classic software agile board',
	},
});
